<template lang="pug">
    v-stepper.elevation-1( v-model='step' )
        v-stepper-header.elevation-0
            v-stepper-step( :complete='step > 1' step='1' ) General
            v-divider
            v-stepper-step( :complete='step > 2' step='2' ) Comercial
            v-divider
            v-stepper-step( :complete='step > 3' step='3' ) Inventario
            v-divider
            v-stepper-step( :complete='step > 4' step='4' ) Productos
        v-stepper-items
            v-stepper-content( step='1' )
                crud-form( ref='formGeneral' submit-text='siguiente' v-bind='formGeneralProps' @submitForm='submitFormGeneral' @calculate='calculateFormGeneral' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' outline @click='submitGenerateInternalCode' ) generar código interno
            v-stepper-content( step='2' )
                crud-form( ref='formComercial' submit-text='siguiente' v-bind='formComercialProps' @reset='resetFormComercial' @submitForm='submitFormComercial' )
                    template( slot='prependContent' )
                        crud-data-table.table-append( checkable no-actions no-auto-width no-search-box no-visual-help no-export ref='tableComercial' show-all v-bind='tableComercialProps' @change-item='calculateTableComercial' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' @click='step--' ) anterior
                        //v-btn.mt-3.mr-3.subheading( block color='info' outline ) agregar sucursal
            v-stepper-content( step='3' )
                crud-form( ref='formInventory' submit-text='siguiente' v-bind='formInventoryProps' @reset='resetFormInventory' @submitForm='submitFormInventory' )
                    template( slot='prependContent' )
                        crud-data-table.table-append( checkable no-actions no-auto-width no-search-box no-visual-help no-export ref='tableInventory' show-all v-bind='tableInventoryProps' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' @click='step--' ) anterior
            v-stepper-content( step='4' )
                crud-form( submit-text='Editar promoción' @submitForm='submitForm' )
                    template( slot='appendContent' )
                        crud-data-table.table-append( checkable no-actions no-auto-width no-search-box no-visual-help no-export ref='tableProducts' show-all v-bind='tableProductsProps' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' @click='step--' ) anterior
                        v-btn.mt-3.mr-3.subheading( block color='info' outline @click='dialog = true' ) agregar productos
        v-dialog( content-class='white' fullscreen transition='dialog-bottom-transition' v-model='dialog' )
            v-toolbar( color='primary' dark flat )
                v-btn( icon @click='dialog = false' )
                    v-icon close
                v-toolbar-title Seleccionar productos
                v-spacer
                v-btn( color='accent' depressed @click='submitDialog' ) confirmar
                    v-icon.ml-2 done_all
            model-data-table(
                ref="dialogTableProducts"
                v-bind="dialogTableProductsProps"
                checkable
                editable
                no-actions
                :defaultLimit="100"
                )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import { CrudDataTable, CrudForm } from '@/components/reusable_components'
//
import BranchOfficeService from '@/services/api/branchOffice'
import FamilyService from '@/services/api/family/FamilyServices'
import MeasurementUnitService from '@/services/api/unitMeasurement/UnitMeasurementService'
import ProductService from '@/services/api/product'
import SubFamilyService from '@/services/api/subfamily/SubfamilyService'
import TagService from '@/services/api/tag/TagServices'
import PromoService from '@/services/api/promo'
import ProviderService from '@/services/api/provider'
import WarehouseService from '@/services/api/warehouse'
import SaleUtils from '@/services/SaleUtils'
//
import GeneralFields from './partials/fields/general'
import ComercialFields from './partials/fields/comercial'
import InventoryFields from './partials/fields/inventory'
//
import ComercialHeaders from './partials/headers/comercial'
import InventoryHeaders from './partials/headers/inventory'
import ProductsHeaders from './partials/headers/products'
import DialogProductsHeaders from './partials/headers/dialogProducts'
//
import MdlProduct from '../../models/Warehouse/WhProduct'
import DialogProductsFilters from './partials/filters/list'
//
export default {
    name: 'promo-create',
    components: {
        'crud-form': CrudForm,
        'crud-data-table': CrudDataTable,
        'model-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        currentBranchOfficeId() {
            return this.currentUser
                ? this.currentUser.hr_employee.g_branch_office
                : 1
        },

        /**
         *
         */
        currentUser() {
            return this.$store.state.AuthModule.user
        },

        /**
         *
         */
        dialogTableProductsProps() {
            return {
                filters: this.dialogTableProductsFilters,
                headers: this.dialogTableProductsHeaders,
                service: MdlProduct,
            }
        },

        /**
         *
         */
        formComercialProps() {
            return {
                fields: this.formComercialFields,
            }
        },

        /**
         *
         */
        formGeneralProps() {
            return {
                fields: this.formGeneralFields,
            }
        },

        /**
         *
         */
        formInventoryProps() {
            return {
                fields: this.formInventoryFields,
            }
        },

        /**
         *
         */
        tableComercialProps() {
            return {
                filters: [],
                headers: ComercialHeaders,
                service: this.tableComercialService,
            }
        },

        /**
         *
         */
        tableInventoryProps() {
            return {
                filters: [],
                headers: InventoryHeaders,
                service: this.tableInventoryService,
            }
        },

        /**
         *
         */
        tableProductsProps() {
            return {
                filters: [],
                headers: ProductsHeaders,
                service: this.tableProductsService,
            }
        },
    },
    data() {
        return {
            dialog: false,
            dialogTableProductsFilters: DialogProductsFilters.slice(),
            dialogTableProductsHeaders: DialogProductsHeaders.slice(),
            formComercialFields: ComercialFields,
            formGeneralFields: GeneralFields,
            formInventoryFields: InventoryFields,
            step: 1,
            tableComercialItems: [],
            tableComercialService: {},
            tableInventoryItems: [],
            tableInventoryService: {},
            tableProductsItems: [],
            tableProductsService: {},
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        async calculateFormGeneral({ field, value, vmodels }) {
            //
            switch (field) {
                case 'wh_family_id':
                    this.formGeneralFields[2].value = value
                    this.formGeneralFields[3].options.data = await SubFamilyService.fetchAllSubfamilyByFamilyId(
                        value
                    )
                    this.formGeneralFields = [...this.formGeneralFields]
                    break
                case 'wh_subfamily_id':
                    this.formGeneralFields[2].value = this.formGeneralFields[3].options.data.find(
                        ({ id }) => value === id
                    ).wh_family_id
                    this.formGeneralFields = [...this.formGeneralFields]
                    break
            }
        },

        /**
         *
         */
        async calculateTableComercial({ idx, item, jdx }) {
            //
            switch (jdx) {
                case 1:
                case 2:
                    item.gains_margin = SaleUtils.getMargin(
                        item.sale_price,
                        item.cost_price
                    )
                    break
            }

            //
            //this.resetTableComercialService()
        },

        /**
         *
         */
        calculateProducts: async function(e) {
            //this.setProductsFieldOptionData( 0, await ProductService.fetchBySearch(e) )
        },

        /**
         *
         */
        computedCostPrice(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.cost_price : 0
        },

        /**
         *
         */
        computedCriticalStock(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.critical_stock : 0
        },

        /**
         *
         */
        computedGainMargin(item) {
            //
            const branch_office = item.branch_offices.find(
                    this.findBranchOffice
                ),
                sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return branch_office && sale_price
                ? SaleUtils.getMargin(
                      sale_price.sale_price,
                      branch_office.cost_price
                  ) + ' %'
                : 0
        },

        /**
         *
         */
        computedSalePrice(item) {
            //
            const sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return sale_price ? sale_price.sale_price : 0
        },

        /**
         *
         */
        findBranchOffice(branch_office) {
            return (
                this.currentBranchOfficeId === branch_office.g_branch_office_id
            )
        },

        /**
         *
         */
        findSalePrice(sale_price) {
            return this.currentBranchOfficeId === sale_price.branch_office_id
        },

        /**
         *
         */
        getPromoRequestData() {
            //
            const generalData = this.$refs.formGeneral.vmodels,
                comercialData = this.$refs.formComercial.vmodels,
                inventoryData = this.$refs.formInventory.vmodels

            //
            return {
                ...generalData,
                ...comercialData,
                ...inventoryData,
                branch_office_data: this.tableInventoryItems
                    .reduce(this.reduceBranchOffice, this.tableComercialItems)
                    .map(this.mapBranchOffice),
                products: [...this.tableProductsItems.map(this.mapProducts)],
                create_promo: true,
            }
        },

        /**
         *
         */
        mapBranchOffice(branch_office) {
            return {
                g_branch_office_id: branch_office.g_branch_office_id,
                cost_price: branch_office.cost_price,
                sale_price: branch_office.sale_price,
                gains_margin: branch_office.gains_margin,
                maximum_stock: branch_office.maximum_stock,
                minimum_stock: branch_office.minimum_stock,
                critical_stock: branch_office.critical_stock,
            }
        },

        /**
         *
         */
        mapBranchOfficeToComercialItem(branchOffice) {
            return {
                ...branchOffice,
                cost_price: branchOffice.cost_price,
                sale_price: branchOffice.salePrice,
                gains_margin: branchOffice.gains_margin,
                g_branch_office_id: branchOffice.g_branch_office_id,
            }
        },

        /**
         *
         */
        mapBranchOfficeToInventoryItem(branchOffice) {
            return {
                ...branchOffice,
                minimum_stock: branchOffice.minimum_stock,
                maximum_stock: branchOffice.maximum_stock,
                critical_stock: branchOffice.critical_stock,
                g_branch_office_id: branchOffice.g_branch_office_id,
            }
        },

        /**
         *
         */
        mapCompositionToProductsItem(composition) {
            return {
                alias_name: '-',
                internal_code: '-',
                name: composition.item_name,
                quantity: composition.quantity_in_promo,
                wh_product_id: composition.item_product_id,
            }
        },

        /**
         *
         */
        mapProducts(product) {
            return {
                quantity: product.quantity,
                wh_product_id: product.wh_product_id,
            }
        },

        /**
         *
         */
        mapSelectedToProductsItem(selected) {
            return {
                ...selected,
                quantity: 1,
                wh_product_id: selected.id,
            }
        },

        /**
         *
         */
        parseErrors(errors) {
            //
            var message = Object.values(errors || {}).reduce(
                (total, curr) => total + ' ' + curr.join(', '),
                ''
            )

            //
            message = message.replace(
                'El campo family id',
                'El nombre de familia'
            )
            message = message.replace(
                'El campo subfamily id',
                'El nombre de subfamilia'
            )
            message = message.replace(
                'El campo product name',
                'El nombre del producto'
            )
            message = message.replace('El campo products.', 'En el producto (')
            message = message.replace('.quantity', '), la cantidad')

            //
            return message
        },

        /**
         *
         */
        async rebuild() {
            //
            this.dialogTableProductsFilters[0].options = await ProviderService.fetchAll()
            this.dialogTableProductsFilters[1].options = await WarehouseService.fetchAll()
            this.dialogTableProductsFilters[3].options = await FamilyService.fetchAll()
            this.dialogTableProductsFilters[4].options = await SubFamilyService.fetchAll()
            this.dialogTableProductsFilters[5].options = await TagService.fetchAll()

            //
            this.dialogTableProductsHeaders[4][
                'computed'
            ] = this.computedCriticalStock
            this.dialogTableProductsHeaders[5][
                'computed'
            ] = this.computedCostPrice
            this.dialogTableProductsHeaders[6][
                'computed'
            ] = this.computedSalePrice
            this.dialogTableProductsHeaders[7][
                'computed'
            ] = this.computedGainMargin

            //
            this.formGeneralFields[4].options.data = this.dialogTableProductsFilters[5].options
            this.formGeneralFields[2].options.data = this.dialogTableProductsFilters[3].options
            this.formGeneralFields[3].options.data = this.dialogTableProductsFilters[4].options
            //
            //this.formInventoryFields[ 1 ].options.data = await MeasurementUnitService.fetchAll()

            //
            this.setTitleTopBar('Editar promoción')
        },

        /**
         *
         */
        reduceBranchOffice(total, curr, idx) {
            //
            total[idx].minimum_stock = curr.minimum_stock
            total[idx].maximum_stock = curr.maximum_stock
            total[idx].critical_stock = curr.critical_stock

            //
            return total
        },

        /**
         *
         */
        async reset() {
            //
            const promo = await PromoService.fetchById(this.$route.params.id),
                branchOffices = await BranchOfficeService.fetchAll()
            // console.log(promo,'promoInfo')
            // console.log(branchOffices,'branchOffices')
            //
            console.log('promo data: ', promo)
            this.formGeneralFields[0].value = promo.name
            this.formGeneralFields[1].value = promo.alias_name
            this.formGeneralFields[2].value = promo.wh_subfamily.wh_family_id
            this.formGeneralFields[3].value = promo.wh_subfamily_id
            this.formGeneralFields[4].value = promo.wh_tags.map(o => o.id)
            this.formGeneralFields[5].value = promo.internal_code
            this.formGeneralFields[6].value = promo.description
            console.log('promo fields: ', this.formGeneralFields)
            //
            //console.log( this.mergePricesOffices(promo.branch_offices, promo.sale_prices) ,'merge')
            let mergeOffices = this.mergePricesOffices(
                promo.branch_offices,
                promo.sale_prices
            )
            this.tableComercialItems = mergeOffices.map(
                this.mapBranchOfficeToComercialItem
            )
            this.tableInventoryItems = mergeOffices.map(
                this.mapBranchOfficeToInventoryItem
            )
            this.tableProductsItems = promo.composition.composition.map(
                this.mapCompositionToProductsItem
            )

            //

            //set comercialForm
            this.formComercialFields[1].value = promo.warranty_days
            this.formComercialFields[2].value = promo.is_tax_free
            this.formComercialFields[3].value = promo.is_salable
            this.formComercialFields[4].value = promo.is_consumable
            //
            // set formInventoryFields
            this.formInventoryFields[1].value = promo.is_repackaged
            this.formInventoryFields[2].value = promo.is_seasonal
            //
            this.resetTableComercialService()
            this.resetTableInventoryService()
            this.resetTableProductsService()

            //
            this.formGeneralFields = [...this.formGeneralFields]
            this.formComercialFields = [...this.formComercialFields]
            this.formInventoryFields = [...this.formInventoryFields]
        },

        /**
         *
         */
        resetFormComercial() {
            //
            this.tableComercialItems = this.tableComercialItems.map(
                this.mapBranchOfficeToComercialItem
            )
            this.resetTableComercialService()

            //
            this.$refs.tableComercial.checkAll()
            this.$refs.tableComercial.checkAll()
        },

        /**
         *
         */
        resetFormInventory() {
            //
            this.tableInventoryItems = this.tableInventoryItems.map(
                this.mapBranchOfficeToInventoryItem
            )
            this.resetTableInventoryService()

            //
            this.$refs.tableInventory.checkAll()
            this.$refs.tableInventory.checkAll()
        },

        /**
         *
         */
        resetTableComercialService() {
            this.tableComercialService = {
                dtFetchData: () => ({
                    data: this.tableComercialItems,
                }),
            }
        },

        /**
         *
         */
        resetTableInventoryService() {
            this.tableInventoryService = {
                dtFetchData: () => ({
                    data: this.tableInventoryItems,
                }),
            }
        },

        /**
         *
         */
        resetTableProductsService() {
            this.tableProductsService = {
                dtFetchData: () => ({
                    data: this.tableProductsItems,
                }),
            }
        },

        /**
         *
         */
        async responseForm(response) {
            switch (response.status) {
                case 'success':
                    return this.showSnackbar(
                        'success',
                        'Exito.',
                        'La promocion fue creada exitosamente.',
                        this.refresh
                    )
                case 'error':
                    return this.showSnackbar(
                        'error',
                        'Error.',
                        this.generateErrorMessage(response)
                    )
            }
        },

        /**
         *
         */
        async showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
        },

        /**
         *
         */
        submitDialog() {
            //
            this.tableProductsItems = this.$refs.dialogTableProducts.selected.map(
                this.mapSelectedToProductsItem
            )
            this.resetTableProductsService()

            //
            this.dialog = false
        },

        /**
         *
         */
        async submitGenerateInternalCode() {
            //
            const {
                error,
                errors,
                message,
                status,
                suggested_code,
            } = await PromoService.fetchSuggestInternalCode(
                this.$refs.formGeneral.vmodels
            )

            //
            switch (status) {
                case 'success':
                    this.resetSnackbarState()
                    this.$refs.formGeneral.vmodels.internal_code = suggested_code
                    this.showSnackbar(
                        'info',
                        'Modificado.',
                        'Se modifico el campo de código interno'
                    )
                    break
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        errors ? this.parseErrors(errors) : error || message
                    )
                    break
            }
        },

        /**
         *
         */
        submitFormGeneral(data) {
            this.step++
        },

        /**
         *
         */
        submitFormComercial(data) {
            this.step++
        },

        /**
         *
         */
        submitFormInventory(data) {
            this.step++
        },

        /**
         *
         */
        async submitForm(data) {
            //
            if (this.tableProductsItems.length < 1) {
                //
                return this.showSnackbar(
                    'error',
                    'Error.',
                    'Se necesita de al menos un producto.'
                )
            }

            //
            //this.$route.params.id
            //console.log(this.$route.params.id,'id params')
            const {
                error,
                errors,
                message,
                status,
            } = await PromoService.update(
                this.$route.params.id,
                this.getPromoRequestData()
            )

            //
            switch (status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        errors ? this.parseErrors(errors) : error || message
                    )
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Promoción agregada.'
                    )
                    this.$router.push({ name: 'promos_list' })
                    break
            }
        },
        /*
         */
        mergePricesOffices(arrBranchOffice, arrPricesSale) {
            return arrBranchOffice.map(office => {
                office.salePrice = arrPricesSale.find(
                    priceSale =>
                        priceSale.branch_office_id === office.g_branch_office_id
                ).sale_price
                office.g_branch_office_id = office.g_branch_office_id
                office.name = office.g_branch_office.name
                //office.internal_code = office
                return office
            })
        },
    },
    mounted() {
        this.rebuild()
        this.reset()
    },
}
</script>

<style>
.table-append {
    padding: 0 3rem;
}
.table-append .table-container {
    width: 100% !important;
}
.table-append .table-container .body-rows {
    width: auto !important;
}
</style>
